import Service from 'react-reservice';

import { IPelicanSectionSettings } from '@aqx-core/common/api/copy-trade/model';
import { ECopyTradeFilter } from '@aqx-core/common/constants/copy-trade';
import { compareColumnSettings } from '@aqx-core/common/services/copy-trade/utils';

export interface ICopyTradeSectionSettingsContext {
  availableStrategySections: ECopyTradeFilter[];
  allStrategySections: IPelicanSectionSettings[];
  editingStrategySections: IPelicanSectionSettings[];
  originalStrategySections: IPelicanSectionSettings[];
  isStrategySectionsLoading: boolean;
  isStrategySectionsDirty: boolean;
  isResetDefaultButtonDisabled: boolean;
}

const defaultContext: ICopyTradeSectionSettingsContext = {
  availableStrategySections: [],
  allStrategySections: [],
  editingStrategySections: [],
  originalStrategySections: [],
  isStrategySectionsLoading: false,
  isStrategySectionsDirty: false,
  isResetDefaultButtonDisabled: false
};

class CopyTradeSectionSettingsService extends Service<ICopyTradeSectionSettingsContext> {
  constructor() {
    super();
    this.context = { ...defaultContext };
  }

  setStrategySectionsLoading = (loading: boolean) => {
    this.context.isStrategySectionsLoading = loading;
  };

  setAvailableStrategySections = (availableStrategySections: ECopyTradeFilter[]) => {
    this.context.availableStrategySections = availableStrategySections;
  };

  setAllStrategySections = (allStrategySections: IPelicanSectionSettings[]) => {
    this.context.allStrategySections = allStrategySections;
  };

  setEditingStrategySections = (editingStrategySections: IPelicanSectionSettings[]) => {
    this.context.editingStrategySections = editingStrategySections;
    if (this.context.originalStrategySections.length > 0) {
      this.updateIsStrategySectionsDirty();
    }
  };

  setOriginalStrategySections = (originalStrategySections: IPelicanSectionSettings[]) => {
    this.context.originalStrategySections = originalStrategySections;
    this.updateIsStrategySectionsDirty();
  };

  private updateIsStrategySectionsDirty = () => {
    const { editingStrategySections, originalStrategySections, allStrategySections } = this.context;
    if (editingStrategySections.length === 0 || originalStrategySections.length === 0) {
      this.context.isStrategySectionsDirty = false;
      return;
    }

    const editingSorted = [...editingStrategySections].sort((a, b) => a.order - b.order);
    const originalSorted = [...originalStrategySections].sort((a, b) => a.order - b.order);

    if (editingSorted.length !== originalSorted.length) {
      this.context.isStrategySectionsDirty = true;
      return;
    }

    this.context.isStrategySectionsDirty = !compareColumnSettings(editingStrategySections, originalStrategySections);
    this.context.isResetDefaultButtonDisabled = compareColumnSettings(editingStrategySections, allStrategySections);
  };
}

export const copyTradeSectionSettingsService = new CopyTradeSectionSettingsService();
